/* ----- Dropdown Hover ----------------------------------------------------- */
$(document).ready(function() {
  $('.dropdown').hover(function() {
    if (window.innerWidth>=768) {
      $(this).addClass('show');
      $(this).find('.dropdown-menu').addClass('show');
    }
  }, function() {
    if (window.innerWidth>=768) {
      $(this).removeClass('show');
      $(this).find('.dropdown-menu').removeClass('show');
    }
  });
});